import { render, staticRenderFns } from "./DnnProfileList.vue?vue&type=template&id=4223ff88&"
import script from "./DnnProfileList.vue?vue&type=script&lang=js&"
export * from "./DnnProfileList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports